import { z } from 'zod'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v1/pagination'

export const timezoneSchema = z.object({
    created_at: z.coerce.date(),
    title: z.string(),
    updated_at: z.coerce.date(),
    uuid: z.string().uuid(),
    value: z.string(),
})

export const timezonesSchema = z.array(timezoneSchema)

export const paginatedTimezonesSchema = z.object({
    data: timezonesSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})
